// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__idxqi","root":"index_root__WxpX-"};